const Constants = {

    GLICOCHECK_ADMIN_ACCESS_TOKEN_NAME: 'gAdminAccessToken'

}

export default Constants;